module.exports = __webpack_public_path__ + "static/media/landing.3b8ca12e.jpg";